import { useEffect, useLayoutEffect, type ReactNode } from "react";
import { NARROW_QUERY, useUi } from "@/state/ui";

/**
 * Keeps `data-theme` on <html> in sync with the store (the store also writes
 * it synchronously on toggle; the layout effect covers hydration / strict
 * mode remounts before any child effect reads CSS variables), follows the
 * OS preference in "system" mode, and tracks the narrow-viewport class.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUi((s) => s.theme);
  const applySystemTheme = useUi((s) => s.applySystemTheme);
  const setNarrow = useUi((s) => s.setNarrow);
  useLayoutEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);
  useEffect(() => {
    const mq = matchMedia("(prefers-color-scheme: dark)");
    const on = (e: MediaQueryListEvent) => applySystemTheme(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [applySystemTheme]);
  useLayoutEffect(() => {
    const mq = matchMedia(NARROW_QUERY);
    setNarrow(mq.matches);
    const on = (e: MediaQueryListEvent) => setNarrow(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [setNarrow]);
  return <>{children}</>;
}
